@switch (activityRecord.record_type) {
  @case ('Questionnaire') {
    <a class="list-item-info">
      <img class="icon" src="assets/images/icons/questionnaire.svg" />
      <div class="text-info" data-cy="text-info">
        <p class="time-space">
          {{ activityRecord.created_at | date: 'yyyy/MM/dd' }}
          <span> ［アンケート］</span>
        </p>
        <p class="activity-name">{{ activityRecord.title }}</p>
        @if (!!activityRecord.category_name) {
          <span class="questionnaire-category">{{ activityRecord.category_name }}</span>
        }
      </div>
    </a>
    <a class="list-item-icon"><i class="fa fa-chevron-right"></i></a>
  }
  @case ('Document') {
    <a class="list-item-info">
      <i class="fa fa-file-text-o"></i>
      <div class="text-info" data-cy="text-info">
        @if (activityRecord.has_active_pickup) {
          <div class="pickup">
            <img src="assets/images/icons/pickup.svg" />
            <span>先生のピックアップ</span>
          </div>
        }
        <p class="time-space">
          {{ activityRecord.created_at | date: 'yyyy/MM/dd' }}
          @if (activityRecord.is_answer) {
            <span> ［課題］</span>
          }
        </p>
        <p class="activity-name">{{ activityRecord.title }}</p>
        <span class="comment-block">
          @if (activityRecord.has_unread_assessment) {
            <a class="badge-noti" data-cy="text-info-badge"></a>
          }
          <i class="fa fa-commenting-o"></i>
        </span>
        {{ activityRecord.assessments_count }}
        @if (!!activityRecord.category_name) {
          <span class="document-category">{{ activityRecord.category_name }}</span>
        }
      </div>
    </a>
    <a class="list-item-icon"><i class="fa fa-chevron-right"></i></a>
  }
}
